// Free-shipping meter: re-reads the cart after every add/change and rewrites the message.
if (!customElements.get('rt-ship-meter')) {
  const formatMoney = (cents) => {
    const dollars = cents / 100;
    return '$' + (Number.isInteger(dollars) ? dollars.toFixed(0) : dollars.toFixed(2));
  };

  class RtShipMeter extends HTMLElement {
    connectedCallback() {
      this.threshold = Number(this.dataset.threshold);
      this.near = Number(this.dataset.near);
      this.mid = Number(this.dataset.mid);
      this.msg = this.querySelector('.rt-ship__msg');
      this.fill = this.querySelector('.rt-ship__fill');
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
      }
      document.addEventListener('rt:cart-updated', (this.onCustom = (e) => this.render(e.detail.total_price)));
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      document.removeEventListener('rt:cart-updated', this.onCustom);
    }

    onCartUpdate(event) {
      const total = event && event.cartData && typeof event.cartData.total_price === 'number' ? event.cartData.total_price : null;
      if (total !== null) return this.render(total);
      fetch(`${window.Shopify && Shopify.routes ? Shopify.routes.root : '/'}cart.js`)
        .then((r) => r.json())
        .then((cart) => this.render(cart.total_price))
        .catch(() => {});
    }

    render(total) {
      const remaining = this.threshold - total;
      let text;
      if (total <= 0) text = `Free shipping on orders over ${formatMoney(this.threshold)}`;
      else if (remaining <= 0) text = "You've unlocked free shipping";
      else if (remaining <= this.near) text = `Almost there: ${formatMoney(remaining)} more ships free`;
      else if (remaining <= this.mid) text = `You're ${formatMoney(remaining)} away from free shipping`;
      else text = `Add ${formatMoney(remaining)} more for free shipping`;
      if (this.msg && this.msg.textContent !== text) {
        this.msg.textContent = text;
        this.classList.remove('rt-ship--pulse');
        void this.offsetWidth;
        this.classList.add('rt-ship--pulse');
      }
      this.classList.toggle('rt-ship--done', total > 0 && remaining <= 0);
      if (this.fill) this.fill.style.width = `${Math.min(100, Math.max(0, (total / this.threshold) * 100))}%`;
    }
  }

  customElements.define('rt-ship-meter', RtShipMeter);
}
